import React from 'react';
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { Locale } from '../../i18n/init';
import { useGetUserResourceReferenceQuery } from '../../app/services/userResourceApi';
import { Markup } from 'interweave';
import ResourcePageUI from '../resources/resourcePage/ResourcePageUI';

const UserResourcePage:React.FC = () => {
  const { userResource} = useParams();
  const [searchParams] = useSearchParams();

  const { data: userResourceRef, isLoading, isSuccess } = useGetUserResourceReferenceQuery({
    code: userResource as string,
    locale: searchParams.get('locale') as Locale,
    copy: Number(searchParams.get('copy'))
  });

  const {t:_} = useTranslation();

  return (
    <div>
      <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item" aria-current="page"><Link to="../" className="text-reset">{_('Dashboard')}</Link></li>
        {(userResourceRef) && (<>
          <li className="breadcrumb-item active" aria-current="page">
            <Markup content={userResourceRef.Object.title} />
          </li>
        </>)}
      </ol>
    </nav>

      {isLoading ? (
        <div className="alert alert-info">{_("Loading")}...</div>
      ) : isSuccess ? (
        <ResourcePageUI resourceRef={userResourceRef} />
      ) : (
        <Alert variant="danger">{_("Unable to load resource to load resource.")} <Link to="../">{_("Back")}</Link></Alert>
      )}
    </div>
  );
};

export default UserResourcePage;
